<iframe [src]="viewerUrl | safe: 'resourceUrl'" allowfullscreen></iframe>
